export default __webpack_public_path__ + "static/media/img_4.3c99c8d3.png";